<template>
  <div class="partner-notice">
    <el-collapse @change="collapseChange" accordion>
      <el-collapse-item :name="item.id" v-for="item in notifyAllData" :key="item.id">
        <template slot="title">
          <span class="item-title">{{item.title}}</span>
          <span class="item-date">{{item.date}}</span>
        </template>
        <div v-html="item.content"></div>
      </el-collapse-item>
      <el-pagination
        @current-change="pageChange"
        layout="prev, pager, next"
        :total="pageTotal">
      </el-pagination>
    </el-collapse>
  </div>
</template>

<script>
  import { partnerNotice, notifyAll,ActnotifyList } from 'api'
    export default {
      data(){
        return {
          notifyAllData: [],
          pageNo:1,
          pageTotal:0,
          c: null
        }
      },
      methods: {
        pageChange(val){
          this.pageNo = val;
        },
        getData(){
          ActnotifyList({
            pageNo:this.pageNo
          }).then(res => {
            if(res.ret === 0){
              this.notifyAllData = res.data.list;
              this.pageTotal = res.data.count;
            }
          });
        },
        collapseChange(id){
          this.notifyAllData.forEach((v,i) => {
    
          })
        }
      },
      watch:{
        pageNo(val) {
          this.getData();
        }
      },
      created(){
        let vis = this;
        // Promise.all([partnerNotice(), notifyAll()])
        // .then(res => {
        //   res[0].ret === 0 ? vis.noticeData = res[0].data : console.log(res[0].msg);
        //   res[1].ret === 0 ? vis.notifyAllData = res[1].data : console.log(res[1].msg);
        // })
        this.getData();
      }
    }
</script>

<style lang="scss" scoped>
.partner-notice{
  width: 800px;
  .item-title{
    padding-left:10px;
    position: relative;
    overflow:hidden;
    white-space: nowrap;
    text-overflow:ellipsis;
  }
  .item-date{
    float: right;
    padding-right: 20px;
  }
  .qrcode{
    margin-right: 2em;
  }
}
</style>





// WEBPACK FOOTER //
// index.vue?36b632de